import React, { useRef, useState, useMemo, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../css/textEditor.module.css";
import { AiOutlineTable } from "react-icons/ai";



/* QuillReactEditor.jsx (with disable feature) */

const EDITOR_WRAPPER_STYLE = {
  background: "#e4f2e6",
  borderRadius: "10px",
};

const injectBrandingStyles = () => {
  const css = `
    .ql-toolbar button,
    .ql-toolbar .ql-picker-label {
      opacity: 0.5;
      transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
    }
    .ql-toolbar button:hover,
    .ql-toolbar .ql-picker-label:hover {
      opacity: 1 !important;
    }
    .ql-toolbar button.ql-active {
      opacity: 1 !important;
      transform: scale(1.15);
    }
    .ql-toolbar button:hover .ql-stroke,
    .ql-toolbar button.ql-active .ql-stroke,
    .ql-toolbar button:hover .ql-fill,
    .ql-toolbar button.ql-active .ql-fill {
      stroke: #205a46 !important;
    }
    .ql-toolbar button.ql-active .ql-stroke {
      stroke-width: 2.2 !important;
    }
    .ql-toolbar .ql-picker.ql-expanded .ql-picker-label {
      opacity: 1 !important;
      font-weight: 600 !important;
      transform: scale(1.05);
      transition: transform 0.2s ease-in-out;
    }
    .ql-container.ql-snow {
      background: white;
      border-radius: 6px;
      border-top: 0 !important;
    }
    .ql-snow .ql-stroke {
      stroke-width: 1.8 !important;
    }
    .ql-snow .ql-fill {
      stroke-width: 1 !important;
    }
    .ql-snow .ql-editor.ql-blank::before {
      font-family: 'DM Sans', sans-serif !important;
      font-style: normal !important;
      font-weight: 400 !important;
      opacity: 1 !important;
      color: #b3c0bd !important;
    }
    .ql-snow .ql-editor {
      font-family: 'DM Sans', sans-serif !important;
    }
    .ql-custom-table-btn {
      font-size: 18px;
      padding: 0 8px;
      color: #205a46 !important;
      border: 1px solid #e3efe7;
      border-radius: 4px;
      cursor: pointer;
      background: white;
    }
    .ql-custom-table-btn:hover {
      background: #e4f2e6;
    }
    .ql-toolbar,
    .ql-toolbar * ,
    .ql-container,
    .ql-editor,
    .ql-picker,
    .ql-picker-label,
    .ql-picker-item {
      font-family: "DM Sans" !important;
    }
     .ql-snow .ql-toolbar .ql-picker-label:hover,
    .ql-snow .ql-toolbar .ql-picker-label:focus,
    .ql-snow .ql-toolbar .ql-picker.ql-expanded .ql-picker-label {
      color: #205a46 !important;       
      border-color: #e3efe7 !important;  
      background: #ffffff !important;
    }
    // .ql-toolbar .ql-picker-label {
    //   border: 1px solid #e3efe7 !important;
    //   border-radius: 6px;
    //   padding: 2px 10px;
    //   background: #e4f2e6;
    // }
   

    .ql-snow .ql-editor h1,
    .ql-snow .ql-editor .ql-size-huge {
      font-size: 2em !important;
      font-weight: bold !important;
    }
    .ql-snow .ql-editor h2,
    .ql-snow .ql-editor .ql-size-large {
      font-size: 1.5em !important;
      font-weight: bold !important;
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
      content: 'Heading 1' !important;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
      content: 'Heading 2' !important;
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
      content: 'Normal' !important;
    }

    .ql-snow .ql-tooltip {
      left: 10px !important;
      color: #205a46 !important;
      border: 1px solid #e3efe7 !important;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
      border-radius: 6px !important;
    }
    .ql-snow .ql-tooltip input[type="text"] {
      color: #205a46 !important;
      border: 1px solid #e3efe7 !important;
    }
    .ql-snow .ql-tooltip a.ql-action::before,
    .ql-snow .ql-tooltip a.ql-remove::before {
      color: #205a46 !important;
      font-weight: 600 !important;
    }
    .ql-snow .ql-tooltip a.ql-action:hover::before,
    .ql-snow .ql-tooltip a.ql-remove:hover::before {
      color: #154030 !important;
    }

    .ql-toolbar button,
    .ql-toolbar .ql-picker-label,
    .ql-toolbar .ql-picker-item {
      color: #205a46 !important;
    }

    .ql-toolbar .ql-stroke {
      stroke: #205a46 !important;
    }

    .ql-toolbar .ql-fill {
      fill: #205a46 !important;
    }
      /* LINK COLOR INSIDE EDITOR */
      .ql-editor a,
      .ql-editor a:visited,
      .ql-editor a:hover,
      .ql-editor a:focus {
        color: #205a46 !important;
      }

      /* TOOLTIP LINKS */
      .ql-snow .ql-tooltip a {
        color: #205a46 !important;
      }

      /* EDIT / SAVE / REMOVE */
      .ql-snow .ql-tooltip a.ql-action::before,
      .ql-snow .ql-tooltip a.ql-remove::before {
        color: #205a46 !important;
      }

      .ql-snow .ql-tooltip a.ql-action:hover::before,
      .ql-snow .ql-tooltip a.ql-remove:hover::before {
        color: #205a46 !important;
        opacity: 0.8;
      }
  `;
  const existing = document.getElementById("quill-brand-styles");
  if (existing) return;
  const style = document.createElement("style");
  style.id = "quill-brand-styles";
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
};

function TableGrid({ onSelect }) {
  const rows = 10;
  const cols = 10;

  const [hR, setHR] = useState(0);
  const [hC, setHC] = useState(0);
  const [isSelecting, setIsSelecting] = useState(false);

  return (
    <div
      style={{
        position: "absolute",
        top: 35,
        left: 0,
        background: "#fff",
        padding: 12,
        borderRadius: 12,
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        zIndex: 9999,
        border: "1px solid #e3efe7",
        userSelect: "none",
      }}
      onMouseLeave={() => {
        if (!isSelecting) {
          setHR(0);
          setHC(0);
        }
      }}
    >
      <div 
        onMouseDown={(e) => {
          e.preventDefault();
          setIsSelecting(true);
        }}
        onMouseUp={(e) => {
          e.preventDefault();
          if (isSelecting && hR > 0 && hC > 0) {
            onSelect(hR, hC);
          }
          setIsSelecting(false);
        }}
      >
        {[...Array(rows)].map((_, r) => (
          <div key={r} style={{ display: "flex" }}>
            {[...Array(cols)].map((_, c) => {
              const active = r < hR && c < hC;
              const rr = r + 1;
              const cc = c + 1;
              return (
                <div
                  key={c}
                  onMouseEnter={() => {
                    setHR(rr);
                    setHC(cc);
                  }}
                  style={{
                    width: 18,
                    height: 18,
                    margin: 1.5,
                    borderRadius: 4,
                    border: active ? "1px solid #3ab67d" : "1px solid transparent",
                    background: active ? "#e4f2e6" : "#e3efe7",
                    cursor: "pointer",
                    transition: "background 0.1s ease",
                  }}
                />
              );
            })}
          </div>
        ))}
      </div>

      <div style={{ marginTop: 8, textAlign: "center", fontSize: "11px", fontWeight: 700, color: "#33584e", letterSpacing: "0.5px" }}>
        {hR} ROWS × {hC} COLUMNS
      </div>
    </div>
  );
}

export default function QuillReactEditor({
  value: initialValue = `<p><strong>Bold Text</strong></p><p><em>Italic Text</em></p>`,
  onChange,
  uploadUrl = "/api/upload",
  useBase64Fallback = true,
  disabled = false,     // NEW PARAM
  greyToolbar = false, 
  dragHandleProps = {},
  rightControl = null,
}) {
  const quillRef = useRef(null);
  const [value, setValue] = useState(initialValue);
  const [showTableGrid, setShowTableGrid] = useState(false);

  const isDisabled = disabled;

  // unique toolbar id per instance
  const toolbarIdRef = useRef(`toolbar-${Math.random().toString(36).slice(2, 9)}`);

  // useEffect(() => {
  //   injectBrandingStyles();
  // }, []);

  useEffect(() => {
  injectBrandingStyles();

 if (greyToolbar) {
  const style = document.createElement("style");
  style.id = "quill-grey-style-" + toolbarIdRef.current;

  style.innerHTML = `
    #${toolbarIdRef.current} {
      background: #e3efe7 !important;
      /* border: 1px solid #e3efe7 !important; */
      /* border-bottom: none !important; */
    }

    #${toolbarIdRef.current} + .ql-container {
      /* border: 1px solid #e3efe7 !important; */
      border-top: none !important;
    }
  `;

  document.head.appendChild(style);
}

}, [greyToolbar]);


  // Apply readOnly mode
  useEffect(() => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      editor.enable(!isDisabled);
    }
  }, [isDisabled]);

  const insertTable = (rows, cols) => {
    if (isDisabled) return;

    const editor = quillRef.current.getEditor();
    const tableModule = editor.getModule("table");

    if (tableModule) {
      // Use native Quill 2.0 table module if available
      tableModule.insertTable(rows, cols);
    } else {
      // Fallback to manual HTML injection
      let html = "<table style='border-collapse: collapse; width:100%;'>";
      for (let r = 0; r < rows; r++) {
        html += "<tr>";
        for (let c = 0; c < cols; c++) {
          html += "<td style='border:1px solid #ccc; padding:8px; min-width:80px;'>&nbsp;</td>";
        }
        html += "</tr>";
      }
      html += "</table>";

      const range = editor.getSelection(true);
      editor.clipboard.dangerouslyPasteHTML(range.index, html);
    }

    setShowTableGrid(false);
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        container: `#${toolbarIdRef.current}`,
        handlers: {
          insertTable: () => {
            if (isDisabled) return;
            setShowTableGrid((prev) => !prev);
          },
          image: function () {
            if (isDisabled) return;

            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/*");
            input.click();

            input.onchange = async () => {
              const file = input.files?.[0];
              if (!file) return;

              const editor = this.quill;
              const range = editor.getSelection(true);
              editor.insertEmbed(
                range.index,
                "image",
                "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
              );

              try {
                const url = await uploadImageWithFallback(
                  file,
                  uploadUrl,
                  useBase64Fallback
                );
                editor.deleteText(range.index, 1);
                editor.insertEmbed(range.index, "image", url);
              } catch (e) {
                console.error(e);
                editor.deleteText(range.index, 1);
                alert("Image upload failed");
              }
            };
          },
        },
      },
      clipboard: { matchVisual: false },
      history: { delay: 2000, maxStack: 500, userOnly: true },
    }),
    [uploadUrl, useBase64Fallback, isDisabled]
  );

  const formats = [
    "header",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "color",
    "background",
    "align",
    "table",
  ];

  async function uploadImageWithFallback(file, url, base64Fallback) {
    try {
      const form = new FormData();
      form.append("file", file);
      const resp = await fetch(url, { method: "POST", body: form });
      if (!resp.ok) throw new Error("upload failed");
      const json = await resp.json();
      return json.url;
    } catch (e) {
      if (base64Fallback) return await fileToDataUrl(file);
      throw e;
    }
  }

  function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  const handleChange = (content, delta, source, editor) => {
    if (isDisabled) return; // block text edits completely
    const html = editor.getHTML();
    const text = editor.getText();
    setValue(content);
    onChange?.({ html: html, text: text });
  };

  return (
    <div className={greyToolbar ? "quill-grey-toolbar" : ""}  style={EDITOR_WRAPPER_STYLE}>
      <div
        id={toolbarIdRef.current}
        style={{
          display: "flex",
          alignItems: "center",
          borderRadius: "10px 10px 0px 0px",
          pointerEvents: isDisabled ? "none" : "auto",
          opacity: isDisabled ? 0.5 : 1,
        }}
      >
        {dragHandleProps && (
          <div {...dragHandleProps} style={{ display: "flex", alignItems: "center", padding: "0 8px", cursor: "grab" }}>
             <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="2.5" cy="2.5" r="1.5" fill="#aaa" />
              <circle cx="2.5" cy="8.5" r="1.5" fill="#aaa" />
              <circle cx="2.5" cy="14.5" r="1.5" fill="#aaa" />
              <circle cx="8.5" cy="2.5" r="1.5" fill="#aaa" />
              <circle cx="8.5" cy="8.5" r="1.5" fill="#aaa" />
              <circle cx="8.5" cy="14.5" r="1.5" fill="#aaa" />
            </svg>
          </div>
        )}

        <select className="ql-size" defaultValue="">
          <option value="huge"></option>
          <option value="large"></option>
          <option value=""></option>
        </select>

        <button className="ql-bold"></button>
        <button className="ql-italic"></button>
        <button className="ql-underline"></button>

        <button className="ql-list" value="ordered"></button>
        <button className="ql-list" value="bullet"></button>

        <button className="ql-link"></button>
        <button className="ql-image"></button>

        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
          <button
            className="ql-custom-table-btn ql-insertTable"
            onClick={() => !isDisabled && setShowTableGrid((s) => !s)}
          >
            {/* <span> <AiOutlineTable /></span>  */}
          </button>

          {showTableGrid && !isDisabled && <TableGrid onSelect={insertTable} />}
        </div>

        <div style={{ flex: 1 }} />
        {rightControl}
      </div>

      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder="Start writing..."
      />
    </div>
  );
}
